import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

const strategies = {
  canva: {
    title: 't(Import from Canva)',
    text: 't(Import a campaign from a Canva design)'
  },
  design: {
    title: 't(Create from Canva Design Template)',
    text: 't(Create a campaign from a Canva design template)'
  },
  scratch: {
    title: 't(Start From Scratch)',
    text: 't(Start with an empty social campaign)'
  },
  truevail: {
    title: 't(Import from Truevail Library)',
    text: 't(Choose from one of Truevail\'s many social campaigns)'
  }
}

const StrategyToken = ({ value }) => (
  <div className="token">
    <strong><T text={ strategies[value].title } /></strong><br />
    <T text={ strategies[value].text } />
  </div>
)

StrategyToken.propTypes = {
  value: PropTypes.string
}

export default StrategyToken
